import React, { Fragment, useEffect, useState } from 'react';
import Snackbar  from '@mui/material/Snackbar';
import MuiAlert  from '@mui/material/Alert';
// import { Alert as MuiAlert, AlertTitle } from '@mui/lab';
import AlertTitle from '@mui/material/AlertTitle';
import message from "../lib/message.js";
import "../config.js";

const GlobalSnackbars = () => {
    const [isOpen, setOpen] = useState(false);
    const [severity, setSeverity] = useState("info");
    const [content, setContent] = useState("");
    useEffect(() => {
        message.info = (msg) => {
            setOpen(true);
            setSeverity("info");
            setContent(msg);
        };
        message.warn = (msg) => {
            setOpen(true);
            setSeverity("warn");
            setContent(msg);
        };
        message.success = (msg) => {
            setOpen(true);
            setSeverity("success");
            setContent(msg);
        };
        message.error = (msg) => {
            setOpen(true);
            setSeverity("error");
            setContent(msg);
        };
    }, [])
    const handleClose = (_, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    return (
        <Fragment>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
                open={isOpen}
                autoHideDuration={global.constants.const_toast_timeout}
                onClose={handleClose}
                // style={{ background: 'blue' }}
            >
                <MuiAlert elevation={6} variant={"outlined"} onClose={handleClose} severity={severity}>
                    <AlertTitle>{severity.toLocaleUpperCase()}</AlertTitle>
                    {content}
                </MuiAlert>
            </Snackbar>
        </Fragment>
    )
}

export default GlobalSnackbars;
